// LA VALUTA SI DECIDE UNA VOLTA SOLA, PER TUTTA LA PAGINA (2026-09-12).
//
// Difetto trovato sul tracciato di un acquisto vero (12/09, atterraggio dagli
// annunci Italia): al caricamento della home partivano una ventina di
// richieste in quattro secondi — otto a /api/geo/currency e una dozzina a
// /api/geo/pricing — e i prezzi venivano chiesti PRIMA in dollari e poi in
// euro. Un visitatore italiano vedeva il prezzo in dollari per un istante.
//
// Le due cause erano distinte e vanno corrette insieme:
//   1. undici componenti chiamano ognuno il proprio useCurrency()/usePricing(),
//      e ogni istanza faceva la sua richiesta. Qui la rilevazione e' UNA,
//      condivisa: la prima che parte crea la promessa, tutte le altre
//      aspettano quella.
//   2. la valuta di ripiego e' USD, quindi il primo giro di prezzi partiva
//      sempre in dollari e veniva rifatto appena arrivava la rilevazione.
//      attendiValuta() permette a usePricing di non chiedere niente finche'
//      la valuta non e' decisa davvero.
//
// La scelta manuale dell'utente, quando c'e', vince e non richiede nessuna
// attesa: e' gia' in localStorage.
import { CURRENCIES, FALLBACK_CURRENCY } from './pricing';

// Un solo posto per il nome della chiave: lo importa anche hooks/useCurrency.
export const CHIAVE_SCELTA = 'lc_currency_override';

const BASE = process.env.REACT_APP_API_URL || '/api';

export function sceltaSalvata() {
  try {
    const s = localStorage.getItem(CHIAVE_SCELTA);
    return CURRENCIES.includes(s) ? s : null;
  } catch { return null; }
}

let promessa = null;
let rilevata = null;

// Una richiesta sola per caricamento di pagina, qualunque sia il numero di
// componenti che la chiedono. Non rifiuta mai: in caso di errore vale il
// ripiego, come faceva prima il catch dentro useCurrency.
export function rilevaValuta() {
  if (promessa) return promessa;
  promessa = fetch(`${BASE}/geo/currency`)
    .then((r) => r.json())
    .then((d) => (CURRENCIES.includes(d?.currency) ? d.currency : FALLBACK_CURRENCY))
    .catch(() => FALLBACK_CURRENCY)
    .then((cur) => { rilevata = cur; return cur; });
  return promessa;
}

// La valuta buona per chiedere i prezzi. Con una scelta manuale si sa subito;
// altrimenti si aspetta la rilevazione invece di indovinare il dollaro.
export function attendiValuta() {
  const s = sceltaSalvata();
  if (s) return Promise.resolve(s);
  return rilevaValuta();
}
